<template>
  <div class="addedit-lead center">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2 class="pl-2">
          {{
            editRoute ? $t("labels.edit_document") : $t("labels.add_document")
          }}
        </h2>
      </div>
    </div>
    <form @submit.prevent="checkValidation()" autocomplete="off">
      <vx-card title="Select Document Type" class="addedit-lead-card">
        <div class="vx-row w-full m-0">
          <div class="vx-col sm: w-full md:w-1/2 mb-2 pl-0">
            <label class="font">{{ $t("labels.document_type") }}</label>
            <v-select
              v-model="document_type"
              :options="documentType"
              label="label"
              class="filter-dropdown mt-1"
              :clearable="false"
              name="document_type"
            />
          </div>
        </div>
      </vx-card>
      <vx-card
        class="addedit-lead-card mt-6"
        :title="this.document_type.label"
        v-if="
          this.document_type.value === 'P' ||
          this.document_type.value === 'SB' ||
          this.document_type.value === 'V' ||
          this.document_type.value === 'O'
        "
      >
        <div class="vx-row w-full m-0">
          <div class="vx-col sm: w-full md:w-1/2 mb-4 pl-0">
            <label class="font">{{ $t("labels.name") }}</label>
            <vs-input
              type="text"
              class="w-full mt-1"
              name="name"
              :placeholder="$t('labels.name')"
              v-model="name"
              icon-no-border
              v-validate="'required'"
            />
            <span class="text-danger text-sm">{{ errors.first("name") }}</span>
          </div>

          <div
            class="vx-col sm: w-full md:w-1/2 mb-4 pl-0"
            v-if="this.document_type.value !== 'O'"
          >
            <label class="font">{{ $t("labels.issuing_country") }}</label>
            <v-select
              class="w-full mt-1"
              v-model="country"
              :options="countries"
              name="country"
              :placeholder="$t('labels.select_country')"
              :reduce="(country) => country.id"
              label="name"
              v-validate="'required'"
            />
            <span class="text-danger text-sm">{{
              errors.first("country")
            }}</span>
          </div>
          <div
            class="vx-col sm: w-full md:w-1/2 mb-4 pl-0"
            v-if="this.document_type.value !== 'O'"
          >
            <label class="font">{{ $t("labels.issuing_authority") }}</label>
            <vs-input
              type="text"
              class="w-full mt-1"
              name="issuing_authority"
              :placeholder="$t('labels.issuing_authority')"
              v-model="issuing_authority"
              icon-no-border
              v-validate="'required'"
            />
            <span class="text-danger text-sm">{{
              errors.first("issuing_authority")
            }}</span>
          </div>
          <div
            class="vx-col sm: w-full md:w-1/2 mb-4 pl-0"
            v-if="this.document_type.value !== 'O'"
          >
            <label class="font">{{ $t("labels.number") }}</label>
            <vs-input
              type="text"
              class="w-full mt-1"
              name="num"
              :placeholder="$t('labels.number')"
              v-model="number"
              icon-no-border
              v-validate="'required'"
            />
            <span class="text-danger text-sm">{{ errors.first("num") }}</span>
          </div>
          <div
            class="vx-col sm: w-full md:w-1/2 mb-4 pl-0"
            v-if="
              this.document_type.value !== 'O' &&
              this.document_type.value === 'V'
            "
          >
            <label class="font">{{ $t("labels.issued_passport_no") }}</label>
            <v-select
              v-model="document_id"
              :options="passport_drop"
              :reduce="(passport_drop) => passport_drop.id"
              label="number"
              :placeholder="$t('labels.issued_passport_no')"
              name="document_id"
              class="mt-1"
              v-validate="'required'"
            />
            <span class="text-danger text-sm">{{
              errors.first("passportNumber")
            }}</span>
          </div>
          <div
            class="vx-col sm: w-full md:w-1/2 mb-4 pl-0"
            v-if="
              this.document_type.value !== 'O' &&
              this.document_type.value === 'V'
            "
          >
            <label class="font">{{ $t("labels.type") }}</label>
            <vs-input
              type="text"
              class="w-full mt-1"
              name="type"
              :placeholder="$t('labels.type')"
              v-model="type"
              icon-no-border
              v-validate="'required'"
            />
            <span class="text-danger text-sm">{{ errors.first("type") }}</span>
          </div>
          <div
            class="vx-col sm: w-full md:w-1/2 mb-4 pl-0"
            v-if="this.document_type.value !== 'O'"
          >
            <label class="font flex items-baseline"
              >{{ $t("labels.issue_date") }}
              <i
                :title="$t('labels.date_placeholder')"
                class="vs-icon notranslate icon-scale vs-button--icon feather icon-info null ml-2 text-primary"
              ></i>
            </label>
            <flat-pickr
              :config="configFromdateTimePicker"
              v-model="issue_date"
              class="mt-1"
              name="issue_date"
              placeholder="Select Date"
              v-validate="'required'"
              dateFormat="d-m-Y"
              inputmode="true"
              @on-change="onFromChange"
            />
            <!--            <span class="text-danger text-sm">{{ errors.first('issue_date') }}</span>-->
          </div>
          <div
            class="vx-col sm: w-full md:w-1/2 mb-4 pl-0"
            v-if="this.document_type.value !== 'O'"
          >
            <label class="font flex items-baseline"
              >{{ $t("labels.expiry_date") }}
              <i
                :title="$t('labels.date_placeholder')"
                class="vs-icon notranslate icon-scale vs-button--icon feather icon-info null ml-2 text-primary"
              ></i>
            </label>
            <flat-pickr
              :config="configTodateTimePicker"
              v-model="expiry_date"
              class="mt-1"
              name="expiry_date"
              inputmode="true"
              placeholder="Select Date"
              v-validate="'required'"
              @on-change="onToChange"
            />
            <!--            <span class="text-danger text-sm">{{ errors.first('expiry_date') }}</span>-->
          </div>
        </div>

        <div class="vx-row w-full m-0">
          <div class="vx-col sm: w-full md:w-1/2 mb-4 pl-0">
            <label class="font">{{ $t("labels.description") }}</label>
            <vs-textarea
              type="text"
              maxlength="255"
              name="description"
              v-model="description"
              class="w-full mt-1 mb-0"
              :placeholder="$t('labels.description')"
              v-validate="'required'"
            />
            <span class="text-danger text-sm">{{
              errors.first("description")
            }}</span>
          </div>
          <div class="vx-col sm: w-full md:w-1/2 mb-4 pl-0">
            <label class="font">{{ $t("labels.select_documents") }}</label>
            <input
              name="url"
              type="file"
              class="vs-input--input normal hasValue mt-1 work"
              v-on:change="uploadImageSuccess($event)"
            />
            <span class="text-danger text-sm">{{ errors.first("url") }}</span>
            <div class="upload-img polaroid mt-4" v-if="document_url">
              <a
                :href="document_url"
                target="_blank"
                v-if="this.fileType === 'image'"
              >
                <img :src="document_url" alt="Image" />
              </a>
              <a
                :href="document_url"
                target="_blank"
                v-else-if="this.fileType === 'word'"
                class="file"
              >
                <img
                  src="./../../../../assets/images/pages/doc.svg"
                  alt="Logo"
                />
              </a>
              <a
                :href="document_url"
                target="_blank"
                v-else-if="this.fileType === 'music'"
                class="file"
              >
                <img
                  src="./../../../../assets/images/pages/music-file.svg"
                  alt="Logo"
                />
              </a>
              <a
                :href="document_url"
                target="_blank"
                v-else-if="this.fileType === 'pdf'"
                class="file"
              >
                <img
                  src="./../../../../assets/images/pages/pdf.svg"
                  alt="Logo"
                />
              </a>
              <a
                :href="document_url"
                target="_blank"
                v-else-if="this.fileType === 'csv'"
                class="file"
              >
                <img
                  src="./../../../../assets/images/pages/csv.svg"
                  alt="Logo"
                />
              </a>
              <a :href="document_url" target="_blank" v-else class="file">
                <img
                  src="./../../../../assets/images/pages/txt.svg"
                  alt="Logo"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="mt-2\ btn-lead flex justify-center">
          <vs-button
            class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
            :disabled="button_loading"
            id="create-port"
            button="submit"
            >{{
              editRoute
                ? $t("labels.update_document")
                : $t("labels.add_document")
            }}</vs-button
          >
        </div>
      </vx-card>
    </form>
  </div>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

export default {
  components: {
    flatPickr,
    moment,
  },
  data() {
    return {
      name: "",
      number: "",
      type: "",
      country_id: "",
      document_type: "",
      issuing_authority: "",
      issue_date: null,
      description: "",
      issuing_country: null,
      expiry_date: null,
      document_url: null,
      documentType: [
        { label: "Passport", value: "P" },
        { label: "Seamen book", value: "SB" },
        { label: "Visa", value: "V" },
        { label: "Other Documents", value: "O" },
      ],
      configFromdateTimePicker: {
        minDate: null,
        maxDate: new Date(),
        altFormat: "d-M-Y",
        allowInput: true,
        dateFormat: "d-M-Y",
      },
      configTodateTimePicker: {
        minDate: null,
        altFormat: "d-M-Y",
        allowInput: true,
        dateFormat: "d-M-Y",
      },
      document_id: "",
      passport_drop: [],
      countries: [],
      passportNumbers: [],
      country: "",
      fileType: "",
      passportNumber: "",
      configDate: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: "M j, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      passportNumberId: "",
    };
  },
  computed: {
    editRoute() {
      if (this.$route.name !== "AddDocument") {
        return this.$route.params.id;
      } else {
        return false;
      }
    },
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    });
  },
  mounted() {
    if (this.editRoute) {
      this.getDocument();
    }
    this.setValidationMessage();
    this.getCountry();
    this.getPassport();
  },
  methods: {
    onFromChange(selectedDates, dateStr) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
    },
    onToChange(selectedDates, dateStr) {
      this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
    },
    checkValidation() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createUpdateDocuments();
        }
      });
    },
    async uploadImageSuccess(event) {
      this.$vs.loading();
      var fileData = event.target.files;
      var input = new FormData();
      input.append("directory", "listing");
      input.append("attachment", event.target.files[0]);
      var response = await this.axios.post("s3/upload", input);
      if (response) {
        let data = response.data.data;
        var file_list = data.url;
        var extension = file_list.split(".").pop();
        if (["png", "jpeg", "jpg", "gif"].includes(extension)) {
          this.fileType = "image";
        }
        if (["doc", "docx"].includes(extension)) {
          this.fileType = "word";
        }
        if (["mp3", "wav"].includes(extension)) {
          this.fileType = "music";
        }
        if (["pdf"].includes(extension)) {
          this.fileType = "pdf";
        }
        if (["csv"].includes(extension)) {
          this.fileType = "csv";
        }
        this.document_url = data.url;
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Success.",
          text: response.data.message,
          color: "success",
          position: "top-right",
        });
      }
    },
    async getPassport() {
      let input = {
        document_type: "P",
        is_active: 1,
      };
      if (this.$store.state.userInfo.type === "A") {
        if (this.$route.params.user_id) {
          input = Object.assign(
            {
              user_id: this.$route.params.user_id,
            },
            input
          );
        } else {
          input = Object.assign(
            {
              user_id: this.$route.params.id,
            },
            input
          );
        }
      }
      // if (this.$route.params.user_id !== false) {
      //   input = Object.assign(
      //     {
      //       user_id: this.$route.params.user_id
      //     },
      //     input
      //   );
      // }
      let response = await this.getHTTPPostResponse(
        "/consultants/list-documents",
        input
      );
      if (response) {
        let data = response.data;
        let passport_drop = data.documents;
        this.passport_drop = passport_drop;
      }
    },
    async getCountry() {
      let response = await this.getHTTPPostResponse("/country/list");
      if (response) {
        let data = response.data;
        let countries = data.countries;
        this.countries = countries;
      }
    },
    async createUpdateDocuments() {
      let passportId = "";
      let passportData = this.passport_drop;
      passportData.forEach((el) => {
        if (this.document_id === el.number) {
          passportId = el.id;
        }
        if (this.document_id === el.id) {
          passportId = el.id;
        }
      });

      let input = {
        name: this.name,
        description: this.description,
        document_type: this.document_type.value,
        document_url: this.document_url,
      };
      if (this.document_type.value !== "O") {
        input = Object.assign(input, {
          issuing_country: this.country,
        });
      }
      if (this.document_type.value !== "O") {
        input = Object.assign(input, {
          number: this.number,
          document_type: this.document_type.value,
          issuing_authority: this.issuing_authority,
          issue_date: moment(this.issue_date).format("Y-M-DD"),
          expiry_date: moment(this.expiry_date).format("Y-M-DD"),
          visa_type: this.type,
          document_id: passportId,
        });
      }
      if (this.$store.state.userInfo.type === "A") {
        if (this.$route.params.user_id) {
          input = Object.assign(
            {
              user_id: this.$route.params.user_id,
            },
            input
          );
        } else {
          input = Object.assign(
            {
              user_id: this.$route.params.id,
            },
            input
          );
        }
      }
      let url = this.editRoute
        ? "/consultants/update-documents/" + this.editRoute
        : "/consultants/add-documents";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-port",
        true
      );
      if (response) {
        history.back();
      }
    },
    async getDocument() {
      let response = await this.getHTTPGetResponse(
        "/consultants/get-document/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let document = data.document;
        this.name = document.name;
        this.number = document.number;
        this.type = document.visa_type;
        // this.country_id = document.country_id;
        this.document_type = this.documentType.find(
          (document_type) => document_type.value === document.document_type
        );
        this.issuing_authority = document.issuing_authority;
        this.issue_date = moment(document.issue_date).format("YYYY-MM-DD");
        this.description = document.description;
        this.country = document.issuing_country;
        this.expiry_date = moment(document.expiry_date).format("YYYY-MM-DD");
        this.document_url = document.document_url;
        this.document_id = document.document_number;
        var file_list = document.document_url;
        var extension = file_list.split(".").pop();
        if (["png", "jpeg", "jpg", "gif"].includes(extension)) {
          this.fileType = "image";
        }
        if (["doc", "docx"].includes(extension)) {
          this.fileType = "word";
        }
        if (["mp3", "wav"].includes(extension)) {
          this.fileType = "music";
        }
        if (["pdf"].includes(extension)) {
          this.fileType = "pdf";
        }
        if (["csv"].includes(extension)) {
          this.fileType = "csv";
        }
      }
    },
    // This function is called when we click on back button of page
    goBackConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: "Confirm",
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: "Are you sure you want leave without saving?",
        accept: this.cancle,
      });
    },
    // function to check all fields while preventing
    checkAllFields() {
      if (this.name || this.fileType) {
        return true;
      } else {
        if (
          ["Visa", "Passport", "Seamen book"].includes(this.document_type.label)
        ) {
          if (
            this.issuing_authority ||
            this.number ||
            this.issue_date ||
            this.expiry_date
          ) {
            return true;
          } else {
            if (["Visa", "Passport"].includes(this.document_type.label)) {
              if (this.country) {
                return true;
              } else {
                if (this.document_type.label === "Visa") {
                  if (this.issued_passport_no || this.type) {
                    return true;
                  } else {
                    return false;
                  }
                } else {
                  return false;
                }
              }
            } else {
              return false;
            }
          }
        } else {
          return false;
        }
      }
    },
    // This function is called when we click on ok button of opened dialogue
    async cancle() {
      history.back();
    },
    // This function is called when we click on cancle button of opened dialogue or brwowser's reload of the page
    preventNav() {
      if (!this.checkAllFields()) {
        return;
      }
      event.preventDefault();
      // Chrome requires returnValue to be set.
      event.returnValue = "";
    },
    // This function is called when we click on back button of page and open new dialogue for confirmation
    goBack() {
      let flag = this.checkAllFields();
      if (flag) {
        if (this.goBackConfirm()) {
          this.preventNav;
          return;
        }
      } else {
        history.back();
      }
    },
  },
};
</script>
<style scoped>
.upload-img img {
  max-height: 120px !important;
  max-width: 170px !important;
  border-radius: 3px;
}
</style>
